import { render, staticRenderFns } from "./benefitModal.vue?vue&type=template&id=2e4c1a3e&scoped=true"
import script from "./benefitModal.vue?vue&type=script&lang=js"
export * from "./benefitModal.vue?vue&type=script&lang=js"
import style0 from "./benefitModal.vue?vue&type=style&index=0&id=2e4c1a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c1a3e",
  null
  
)

export default component.exports